import { useLocation } from 'react-router';

export function useQuery() {
  const query = new URLSearchParams(useLocation().search);
  return query;
}

export function useGetQuery(name: string) {
  const query = new URLSearchParams(useLocation().search);
  return query.get(name);
}

export function useGetAllQuery(name: string) {
  const query = new URLSearchParams(useLocation().search);
  return query.getAll(name);
}
export const getUrlQueryValue = (query: string) => {
  return new URLSearchParams(window.location.search)?.get(query);
};
